import posthog from 'posthog-js'

const POSTHOG_PROJECT_TOKEN = import.meta.env.VITE_POSTHOG_PROJECT_TOKEN
const NODE_ENV = import.meta.env.VITE_NODE_ENV
const POSTHOG_PROJECT_ID = '418892'
const POSTHOG_API_HOST = 'https://g.quill.com.br'
const isPostHogEnabled = NODE_ENV === 'prod' && Boolean(POSTHOG_PROJECT_TOKEN)

type PostHogProperties = Record<string, unknown>

let isPostHogInitialized = false

export const initPostHog = () => {
  if (
    !isPostHogEnabled ||
    typeof window === 'undefined' ||
    isPostHogInitialized
  )
    return

  posthog.init(POSTHOG_PROJECT_TOKEN, {
    api_host: POSTHOG_API_HOST,
    defaults: '2026-01-30'
  })

  isPostHogInitialized = true
}

export const identifyPostHogUser = (payload: {
  userId: string
  email?: string
  name?: string
  role?: string
  companyId?: string
  companyName?: string
  companyCnpj?: string
}) => {
  if (!isPostHogEnabled || !payload.userId || typeof window === 'undefined')
    return

  initPostHog()

  posthog.identify(payload.userId, {
    email: payload.email || '',
    name: payload.name || '',
    role: payload.role || '',
    company_id: payload.companyId || '',
    company_name: payload.companyName || '',
    company_cnpj: payload.companyCnpj || '',
    posthog_project_id: POSTHOG_PROJECT_ID
  })

  if (payload.companyId) {
    posthog.group('company', payload.companyId, {
      name: payload.companyName || '',
      cnpj: payload.companyCnpj || ''
    })
  }
}

export const capturePostHogPageview = (
  path: string,
  properties: PostHogProperties = {}
) => {
  if (!isPostHogEnabled || !path || typeof window === 'undefined') return

  initPostHog()

  posthog.capture('$pageview', {
    path,
    ...properties
  })
}

export const trackPostHogEvent = (
  event: string,
  properties: PostHogProperties = {}
) => {
  if (!isPostHogEnabled || !event || typeof window === 'undefined') return

  initPostHog()
  posthog.capture(event, properties)
}

export const resetPostHog = () => {
  if (!isPostHogEnabled || typeof window === 'undefined') return
  posthog.reset()
}
